import React from 'react'
import { Typography } from '@mui/material'
import { SmartDialog } from '../../generic/utilities/SmartDialog'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'

/**
 * OperationPendingChangesDialog (C11, §8.7) — la confirmación de cambios pendientes al cambiar de
 * versión seleccionada en la vista OPERATIONS (S11, `RN-02.12` ampliada en H5).
 *
 * Se resuelve ENTERAMENTE en la UI: `E-OPL-11` fue retirado antes del GATE 2, así que Sun no
 * rechaza nada por cambios pendientes — no hay 409 ni literal de error. Las dos salidas son
 * explícitas: guardar (commit, N8) o descartar (revert del ámbito, N9). Solo después de elegir una
 * se carga la otra versión, de modo que lo pendiente ni se pierde ni se arrastra en silencio.
 */
const OperationPendingChangesDialog = ({ open = false, onSave = () => {}, onDiscard = () => {}, onCancel = () => {} }) => {
  const { t_ } = useSmartTranslation()

  return (
    <SmartDialog
      setOpen={open}
      title={{ render: <Typography variant='h6'>{t_('Save changes')}</Typography> }}
      message={
        <span data-testid='operation-pending-changes-message'>{t_('You have unsaved changes in this operation')}</span>
      }
      accept
      acceptLabel={t_('Save')}
      acceptCallback={onSave}
      cancel
      cancelLabel={t_('Discard changes')}
      cancelCallback={onDiscard}
      close
      closeCallback={onCancel}
      autoClose={false}
    />
  )
}

export default OperationPendingChangesDialog
